module.exports = __webpack_public_path__ + "assets/img/covers-sm.1db67870.jpg";